var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8029_2736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_2736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_2736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8029_2736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8029_2736)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_8029_2736)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8029_2736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5H5V19H19V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8029_2736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 5.875C6.52792 5.875 5.875 6.52792 5.875 7.33333V9.95833C5.875 10.2805 6.13617 10.5417 6.45833 10.5417H7.04167C7.36383 10.5417 7.625 10.2805 7.625 9.95833V7.625H9.95833C10.2805 7.625 10.5417 7.36383 10.5417 7.04167V6.45833C10.5417 6.13617 10.2805 5.875 9.95833 5.875H7.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 5.875C17.4722 5.875 18.1252 6.52792 18.1252 7.33333V9.95833C18.1252 10.2805 17.864 10.5417 17.5418 10.5417H16.9585C16.6363 10.5417 16.3752 10.2805 16.3752 9.95833V7.625H14.0418C13.7197 7.625 13.4585 7.36383 13.4585 7.04167V6.45833C13.4585 6.13617 13.7197 5.875 14.0418 5.875H16.6668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 18.1251C17.4722 18.1251 18.1252 17.4722 18.1252 16.6668V14.0418C18.1252 13.7196 17.864 13.4585 17.5418 13.4585H16.9585C16.6363 13.4585 16.3752 13.7196 16.3752 14.0418V16.3751H14.0418C13.7197 16.3751 13.4585 16.6363 13.4585 16.9585V17.5418C13.4585 17.864 13.7197 18.1251 14.0418 18.1251H16.6668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.875 16.6668C5.875 17.4722 6.52792 18.1251 7.33333 18.1251H9.95833C10.2805 18.1251 10.5417 17.864 10.5417 17.5418V16.9585C10.5417 16.6363 10.2805 16.3751 9.95833 16.3751H7.625V14.0418C7.625 13.7196 7.36383 13.4585 7.04167 13.4585H6.45833C6.13617 13.4585 5.875 13.7196 5.875 14.0418V16.6668Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8029_2736",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8029_2736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitView);
export default __webpack_public_path__ + "static/media/FitView.d865282971229c52206d64773d77b131.svg";
export { ForwardRef as ReactComponent };